export default __webpack_public_path__ + "static/media/Footer_logoBIIB.8ea9c9da.png";